export const SCORE_LIMIT_TO_PASS = 80;